export const LOGO_TYPE = { LR: 'LR', CLINIC: 'clinic' };
export const APP_TYPES = { MAIN: 'main', EFAX: 'efax' };
const PAGE_CONFIG = {
    [APP_TYPES.MAIN]: {
        mainLogo: LOGO_TYPE.CLINIC,
        logoClass: 'main-logo',
        headerOptions: {},
        defaultClinic:true,
        auth:{
            providers:[]
        },
        users:{
            roleManagement:'ROLE MANAGEMENT'
        },
        efax:{

        },
        profile:{
            editable:true,
            multifactorAuth:true,
            termsAndCondition:true
        },
        meta: {
            home: {
                'metaTitle': "Healthcare Automation & Analytics | iNaira Healthcare",
                'metaDesc': "Offers powerful solutions in EMR process automation that significantly reduce preparation times for provider offices",
            },
            login: {
                'metaTitle': "Healthcare Automation & Analytics | iNaira Healthcare - Login",
                'metaDesc': "Validate registered users by accepting user credentials",
            },
            signup: {
                'metaTitle': "Healthcare Automation & Analytics | iNaira Healthcare - Signup",
                'metaDesc': " Register a new user to access the health care services",
            }
        }
    },
    [APP_TYPES.EFAX]: {
        mainLogo: LOGO_TYPE.LR,
        logoClass: 'lr-logo',
        defaultClinic:false,
        headerOptions: {
            activeLinks: ["efax","user-management"],
            headerClass: 'lr-style',
            showClinicName:true
        },
        auth:{
            providers:`${process.env.REACT_APP_LRI_CUSTOM_PROVIDERS}`.split(",").map(id=>({id,custom:true}))
        },
        users:{
            signUp:'USER_ONBOARDING'
        },
        efax:{
            inlineListBtn:true
        },
        profile:{
            editable:false,
            multifactorAuth:false,
            termsAndCondition:false
        },
        meta: {
            home: {
                'metaTitle': "Fax Automation | LeadingReach",
                'metaDesc': "Offers powerful solutions in EMR process automation that significantly reduce preparation times for provider offices",
            },
            login: {
                'metaTitle': "Fax Automation | LeadingReach - Login",
                'metaDesc': "Validate registered users by accepting user credentials",
            },
            signup: {
                'metaTitle': "Fax Automation | LeadingReach - Signup",
                'metaDesc': " Register a new user to access the health care services",
            }
        }
    }
}
class AppConfig {
    constructor(props) {
        this.appType = props?.appType || APP_TYPES.MAIN;
        this.config = { ...(PAGE_CONFIG[this.appType] || PAGE_CONFIG[APP_TYPES.MAIN]), ...props };
    }
    static init(props) {
        AppConfig.current = AppConfig.current || new AppConfig(props);
        return AppConfig.current;
    }
}
export const appConfig = () => AppConfig.current || {};
export const initAppConfig = (props) => AppConfig.init(props);
